import * as React from 'react'
import { observer, inject } from 'mobx-react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { ICredit } from '../../../../Model/Questionnaire'
import {
    getAlreadyNeedPaidSum,
    getCurrentDebtByCreditBody,
    getLastPenaltyAmountFromList,
    getPaymentSchedule,
    getPaymentsSum,
    getPenaltiesSum
} from '../../../../Helpers/PaymentScheduleHelper'
import { toJS } from 'mobx'
// import { PaymentType } from '../../../../Model/Payment'
import * as _ from 'lodash'
import { PaymentType } from '../../../../Model/Payment'

export interface IDebtInfoViewProps {
    credit: ICredit
    localizationStore?: LocalizationStore,
    anonymousView?: boolean
}

@inject('localizationStore')
@observer
export default class DebtInfoView extends React.Component<IDebtInfoViewProps> {
    render() {
        const {
            localizationStore,
            credit,
            anonymousView
        } = this.props

        if (!credit || !credit.creditDetail || !credit.creditDetail.totalSum) {
            return (
                <div>
                    <p className="text-center">
                        {localizationStore!.t('totalSum not calculated')}
                    </p>
                </div>
            )
        }

        let penalty = getLastPenaltyAmountFromList(toJS(credit.penalties))
        let paymentsPenaltiesSum = getPenaltiesSum(credit.payments)
        let penaltyNotPayed = paymentsPenaltiesSum - penalty

        let scheduleArr = credit ? getPaymentSchedule(credit.creditCondition.paymentsScheduleJson) : []

        let alreadyNeedPaidSumBySchedule =
            getAlreadyNeedPaidSum(
                scheduleArr,
                credit.creditCondition.prepaymentSum)

        let paidSumBySchedule = getPaymentsSum(credit.payments.filter(
            x =>
                x.paymentType === PaymentType.MonthlyPayment ||
                x.paymentType === PaymentType.Prepayment ||
                x.paymentType === PaymentType.None))

        let paidSumByScheduleNotPayed = paidSumBySchedule - alreadyNeedPaidSumBySchedule

        let totalNeedPaidSum = penalty + alreadyNeedPaidSumBySchedule
        let totalPaid = paymentsPenaltiesSum + paidSumBySchedule
        let totalDiff = totalPaid - totalNeedPaidSum

        let loanRepaymentAmount = credit.creditDetail.totalSum - credit.creditDetail.balance

        let currentDebtByCreditBody = getCurrentDebtByCreditBody(
            credit.creditDetail.balance,
            scheduleArr,
            credit.creditCondition.prepaymentSum)
        return (
            <div className="container debtInfo pt-1 font-weight-bold text-right">
                <div className="row">
                    <div className="col-3" />
                    <div className="col-3">
                        {localizationStore!.t('paymentsScheduleJson')}
                    </div>
                    <div className="col-3">
                        {localizationStore!.t('Penalty')}
                    </div>
                    <div className="col-3">
                        {localizationStore!.t('totalSum')}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3">
                        {localizationStore!.t('Accrued')}
                    </div>
                    <div className="col-3">
                        {_.round(alreadyNeedPaidSumBySchedule, 2).toFixed(2)}
                    </div>
                    <div className="col-3">
                        {_.round(penalty, 2).toFixed(2)}
                    </div>
                    <div className="col-3">
                        {_.round(totalNeedPaidSum, 2).toFixed(2)}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3">
                        {localizationStore!.t('Paid')}
                    </div>
                    <div className="col-3">
                        {_.round(paidSumBySchedule, 2).toFixed(2)}
                    </div>
                    <div className="col-3">
                        {_.round(paymentsPenaltiesSum, 2).toFixed(2)}
                    </div>
                    <div className="col-3">
                        {_.round(totalPaid, 2).toFixed(2)}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3">
                        {localizationStore!.t('Remaining (debt)')}
                    </div>
                    <div className={`col-3 ${paidSumByScheduleNotPayed < 0 ? 'text-danger' : 'text-success'}`}>
                        {_.round(paidSumByScheduleNotPayed, 2).toFixed(2)}
                    </div>
                    <div className={`col-3 ${penaltyNotPayed < 0 ? 'text-danger' : 'text-success'}`}>
                        {_.round(penaltyNotPayed, 2).toFixed(2)}
                    </div>
                    <div className={`col-3 ${totalDiff < 0 ? 'text-danger' : 'text-success'}`}>
                        {_.round(totalDiff, 2).toFixed(2)}
                    </div>
                </div>
                <hr />

                <div className="row">
                    <div className="col-12">
                        <p>{`${localizationStore!.t('Loan repayment amount')}: ` +
                            `${_.round(loanRepaymentAmount, 2).toFixed(2)}`}</p>
                    </div>
                </div>

                <div hidden={anonymousView} className="row">
                    <div className="col-12">
                        <p>{`${localizationStore!.t('currentDebtByCreditBody')}: ` +
                            `${_.round(currentDebtByCreditBody, 2).toFixed(2)}`}</p>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/TroubleEvent/DebtInfoView/index.tsx